import errors from "./errors";
import { Section } from "./jobs-flow/Section";
import { SaveButton } from "./components/SaveButton";
import { Validator } from "./snippets/Validator";
import { CRUDFabric } from "./CRUDs/CRUDFabric";

const validation_fields = [
    'first_name',
    'last_name',
    'address',
    'email',
   // 'position'
];

const regexEmail = /^\S+@\S+\.\S+$/;

const permissions = {
    'worker': ['worker'],
    'customer_service' : ['worker','cockpit_worker'],
    'supervisor' : ['worker','cockpit_worker', 'jobs_managment','vehicle_management', 'task_manage'],
    'general_manager' : ['worker','cockpit_worker', 'jobs_managment','email_managment', 'vehicle_management', 'payroll_managment', 'report_management', 'services_customizations', 'manager', 'task_manage'],
    'owner': ['worker','cockpit_worker', 'jobs_managment','email_managment', 'vehicle_management', 'payroll_managment', 'report_management', 'services_customizations', 'manager', 'business_settings', 'task_manage']
}


export default {
    init() {
        this.createEmployee();
        this.createEmployeeModal();
        this.changePermissions();
        this.changeSalaryType();
        this.emailInput();
        this.employeeMoreInfo();
        this.deletePicture();
        this.deleteDocument();
        this.anotherListners();
        this.initPagination();
        this.dimInactiveWorkers();
        this.initEmployeeDropzone();
        this.initLogs();
    },
    createEmployee() {

        const checkFields = ()=>{

            if(this.validationFormFields('add-employee-form',new FormData($('#add-employee-form')[0]),validation_fields)
                && regexEmail.test($('#create-employee-modal #email').val()))
                $(`#add-employee-form #add-employee-submit-form`).attr('disabled',false)
            else
                $(`#add-employee-form #add-employee-submit-form`).attr('disabled',true)
        }

        for(let field of validation_fields){
            $(`#add-employee-form *[name=${field}]`).on({
                input:checkFields,
                change:checkFields,
            })
        }

        $('body').on('click', '#add-employee-submit-form', (e) => {
            e.preventDefault();

            let SaveBtn = new SaveButton();
            $('#add-employee-submit-form').prop('disabled', true);
            errors.hideAlerts();
            let form = $('#add-employee-form')[0];
            const formData = new FormData(form);

            formData.set('weekly_salary_input', formData.get('weekly_salary_input').replace('$', ''));
            formData.set('hour_salary_input', formData.get('hour_salary_input').replace('$', ''));

            if($('[name=change_permissions]').prop('checked')){
                const permissionsSelector = $('.permission').find('input[type=checkbox]:checked').toArray();
                const permissions = permissionsSelector.map((elem) => {
                    return elem.getAttribute('id');
                });
                formData.append('permissions', permissions);
            }
                formData.append('position', $('#modal_permissions #position').val())

                    if (this.validationFormFields('add-employee-form', formData, validation_fields, true)  ) {
                $.ajax({
                    type: 'POST',
                    url: '/employees/create',
                    data: formData,
                    processData: false,
                    contentType: false,
                    beforeSend: () => {
                        SaveBtn.startLoading();
                    },
                    success: (response) => {
                        SaveBtn.stopLoading(true).then(() => {
                            SaveBtn.showSuccess()
                                .then(() => {
                                this.reloadTable();
                                $('#create-employee-modal').modal('hide');
                                setTimeout(() => window.location.reload(), 500);
                                })
                        })
                    },
                    error: function (response) {
                        if (response.responseJSON && response.responseJSON.billing_url) {
                            window.location.assign(response.responseJSON.billing_url);
                            return;
                        }
                        SaveBtn.stopLoading().then( () => {
                            SaveBtn.showError().then(()=>{
                                let err = response.responseJSON.errors;
                                errors.showAlerts(err);
                            })
                        });
                    },
                    complete: function(response) {
                        $('#add-employee-submit-form').prop('disabled', false);
                    }
                });
            }else{
                $('#add-employee-submit-form').prop('disabled', false);
            }
        });
    },

    createEmployeeModal() {
        let $this = this;
        $('body').on('click', '.create_employee_modal_show', function(e) {
            $this.hideOrShowPhoto();
            $('#alarm').removeClass('d-none');
            $('#personal_photo').prop('disabled', true);
            $('#documents').prop('disabled', true);
            e.preventDefault();
            errors.hideAlerts();
            $('#title').text('Add Employee');
            $('#create-employee-modal').modal('show');
            $('#create-employee-modal :input').val('');
            $('#social_security').mask('000-00-0000', {placeholder: '___-__-____'});
            $('#phone_number').mask('000-000-0000', {placeholder: '___-___-____'});

            // let's show permission modal
                $('#create-employee-modal #personal_permissions').on('click', (e) => {
                    $('#modal_permissions').modal('show')
                    let role = $('#modal_permissions #position').val()
                        for (let permission of $('#permissions .permission input[type=checkbox]')) {
                            permission = $(permission);
                            if (permissions[role].indexOf(permission.attr('id')) != -1) {
                                permission.prop('checked', true);
                            } else {
                                permission.prop('checked', false);
                            }
                        }

                })

            //check permissions on modal close
            $('#create-employee-modal .close').on('click', (e) => {
                $('[name=change_permissions]').prop('checked', false);

                const permissionsSelector = $('.permission').find('input[type=checkbox]').toArray();
                for (let permission of permissionsSelector) {
                    $(permission).prop('checked', false);
                }
            });
            $('[name=weekly_salary_input], [name=hour_salary_input]').on('input', (e) => {
                const input = $(e.target);
                const value = input.val();
                const floatUSDPreg = /\$\d+\.?(\d{1,2})?$|\$$/;
                const valid = !!value.match(floatUSDPreg)
                if (!valid) input.val(value.slice(0, -1));
                if (!value) input.val('$');
            });
        });
    },
    changePermissions() {
        $('#save-permissions').on('click', (e) => {

            $('[name=change_permissions]').prop('checked', true);
                const permissionsSelector = $('.permission').find('input[type=checkbox]:checked').toArray();
                const permissions = permissionsSelector.map((elem) => {
                    return elem.getAttribute('id');
                });
                const employeeId = $('#permissions').attr('data-employee-id');
                const employeePosition =  $('#modal_permissions #position').val();
                if (employeeId) {
                $.ajax({
                    method: 'POST',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: {
                        id: $('#permissions').attr('data-employee-id'),
                        permissions: permissions.join(','),
                        position:employeePosition
                    },
                    url: `/employees/employee/${employeeId}/change-permissions`,
                    success: (response) => {
                        if (response != 'error') {
                            window.location.reload() //$(`tr#${employeeId} td [data-user_id=${employeeId}] span.permission-title`).text(response);
                        }
                    }
                });
            }
        });
    },
    changeSalaryType() {
        $('body').on('change', '#add-employee-form :checkbox', function(e) {
            e.preventDefault();
            $('#add-employee-form :checkbox').each(function(i, el) {
                $(el).prop('checked', false)
                $('#'+ this.id +'_input').val('$');
                $('#'+ this.id +'_input').addClass('d-none');
            });
            if ( $(this).prop('checked', true) ) {
                $('#'+ this.id +'_input').removeClass('d-none');
            }
        });
    },
    reloadTable() {
        let search = $('#search_employee').val();
        $.ajax({
            type: 'GET',
            url: '/employees',
            data: ({
                search: search,
            }),
            success: function (response) {
                $('.employee-management-table').html(response);
            },
        });
    },
    employeeEdit() {
        let $this = this;
        $('body').on('click', '.edit', function(e) {
            e.preventDefault();
            $('#alarm').addClass('d-none');
            $('#personal_photo').prop('disabled', false);
            $('#documents').prop('disabled', false);
            errors.hideAlerts();
            let id = $(this).data('id');
            $('#title').text('Edit Employee');
            $.ajax({
                type: 'GET',
                url: '/employees/employee',
                data: ({
                    id: id,
                }),
                success: function (response) {
                    $('.modal-window-actions').css({'display': 'none'});
                    $('#create-employee-modal #first_name').val(response.first_name);
                    $('#create-employee-modal #last_name').val(response.last_name);
                    $('#create-employee-modal #phone_number').mask('999-99-9999', {placeholder: '___-__-____'});
                    $('#create-employee-modal #phone_number').val(response.phone);
                    $('#modal_permissions #position').val(response.position);
                    $('#create-employee-modal #pos_access').val(response.access_to_pos);
                    $('#create-employee-modal #user_id').val(response.id);
                    $('#create-employee-modal #email').val(response.email);
                    $('#create-employee-modal #address').val(response.address);
                    $('#create-employee-modal #activity').val(response.activity);
                    $('#create-employee-modal #social_security').mask('999-99-9999', {placeholder: '___-__-____'});
                    $('#create-employee-modal #social_security').val(response.social_security);
                    $('#create-employee-modal #info').val(response.info);

                    $('#personal_permissions').text('Change Permissions');
                    for (let permission of $('#permissions .permission input[type=checkbox]')) {
                        permission = $(permission);
                        if (response.permissions.indexOf(permission.attr('id')) != -1) {
                            permission.prop('checked', true);
                        } else {
                            permission.prop('checked', false);
                        }
                    }
                    // $this.hideOrShowEmail(response.position);
                    $('#create-employee-modal').modal('show');
                    $this.hideOrShowPhoto(response.picture);
                    if (response.picture) {
                        $.ajax({url: '/employees/photo', method: 'GET', data: ({ id: id }), success: (response) => { $('#photo_outer').html(response); }});
                    } else {
                        $.ajax({url: '/employees/photo', method: 'GET', success: (response) => { $('#photo_outer').html(response); }});
                    }
                    if (response.salary_type) {
                        if (response.salary_type === 'weekly') {
                            $('#weekly_salary').prop('checked', true);
                            $('#hour_salary').prop('checked', false);
                            $('#weekly_salary_input').val(`$${response.salary}`);
                            $('#weekly_salary_input').removeClass('d-none');
                            $('#hour_salary_input').val('$');
                            $('#hour_salary_input').addClass('d-none');
                        }
                        if (response.salary_type === 'per_hour') {
                            $('#hour_salary').prop('checked', true);
                            $('#weekly_salary').prop('checked', false);
                            $('#hour_salary_input').val(`$${response.salary}`);
                            $('#hour_salary_input').removeClass('d-none');
                            $('#weekly_salary_input').val('$');
                            $('#weekly_salary_input').addClass('d-none');
                        }
                    }else{
                        $('#hour_salary').prop('checked', false);
                        $('#weekly_salary').prop('checked', false);
                        $('#hour_salary_input').val('$');
                        $('#weekly_salary_input').val('$');
                        $('#hour_salary_input').addClass('d-none');
                        $('#weekly_salary_input').addClass('d-none');

                    }
                    $this.getDocuments(id);
                },
            });
        });
    },
    emailInput() {
        let $this = this;
        $('body').on('change', '#position', function(e) {
            e.preventDefault();
        });
    },
    hideOrShowEmail(position) {
        if (position == 'manager') {
            $('#email_asterisk').removeClass('d-none');
            $('#pos_outer').addClass('d-none');
            $('#pos_access').val('');
        }else{
            $('#email_asterisk').addClass('d-none');
            $('#pos_outer').removeClass('d-none');
        }
    },
    hideOrShowPhoto(show) {
        if (show) {
            $('#personal_photo_show').removeClass('d-none');
            $('#personal_photo').addClass('d-none');
        }else{
            $('#personal_photo').removeClass('d-none');
            $('#personal_photo_show').addClass('d-none');
        }
    },
    getDocuments(id) {
        $('#documents_outer').html('');
        $.ajax({
            type: 'GET',
            url: '/employees/documents',
            data: ({
                id: id,
            }),
            success: function (response) {
                $('#documents_outer').html(response);
            },
        });
    },
    employeeMoreInfo() {
        $('body').on('click', '.account_collapse', function(e) {
            e.preventDefault();
            let user_id = $(this).data('user_id');
            if ($('#employee-' + user_id).hasClass("d-none")) {
                $('#employee-' + user_id).removeClass('d-none');
            } else {
                $('#employee-' + user_id).addClass('d-none');
            }

            if ($('.account_info#account_'+user_id).hasClass('expanded')) {
                $('.account_info#account_'+user_id).removeClass('expanded');
                $('.account_info#account_'+user_id).html('');
            }else{
                $.ajax({
                    type: 'GET',
                    url: '/employees/employee/' + user_id + '/info',
                    data: ({
                        user_id: user_id,
                    }),
                    success: function (response) {
                        $('#form-container').html(response);
                        //$('#employee-info-modal').modal('show');
                        $('input#phone-id').val(user_id);
                    },
                });
            }
        });
    },
    deletePicture() {
        $('body').on('click', '#delete_picture', function(e) {
            e.preventDefault();
            let data = {
                user_id: $('#user_id').val(),
            };
            let url = '/employees/delete-image';
            $.ajax({
                type: 'POST',
                url: url,
                data: (data),
                success: function (response) {
                    $('#photo_outer').html(response);
                },
            });
        });
    },
    deleteDocument() {
        $('body').on('click', '.delete_doc', function(e) {
            let data = null;
            let url = null;
            if (window.location.pathname == '/employees') {
                data = {
                    user_id: $('#user_id').val(),
                    document: $(this).attr('data-doc-name'),
                };
                url = '/employees/delete-document';
            }
            if (window.location.pathname == '/notes') {
                data = {
                    note_id: $('#note-text-id').val(),
                    document: $($($(this).closest('.doc_name_outer')[0]).find('.doc_name')[0]).text(),
                };
                url = '/notes/delete-document';
            }
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: url,
                data: (data),
                success: function (response) {
                    $('#documents_outer').html(response);
                    $('#documents_desktop').html(response);
                },
            });
        });
    },

    dimInactiveWorkers(){
        let rows = $('#employee_table').find('.row_user')
        rows.each(function (key,item){
            $(item).data('employee_status') ? $(item).css('color', '') : $(item).css('color', 'grey')
        })
    },

    anotherListners() {

        $("#app").on('click', '.employee-menu', (e) => {
            const employeeId = $(e.target).closest('.row_user').attr('data-employee_id');
            const isAdmin = $(e.target).closest('.row_user').attr('data-is_admin');
            const hasPhone = $(e.target).closest('.row_user').attr('data-has_phone');
            $('#permissions').attr('data-employee-id', employeeId);
            $('#permissions').attr('data-is_admin', isAdmin);

            //скрываем, если нет телефона
           if(hasPhone == 0) {
               $('.modal-window-actions').find('.call').addClass('d-none')
               $('.modal-window-actions').find('.email').removeClass('d-none')
           }else {
               $('.modal-window-actions').find('.call').removeClass('d-none')
               $('.modal-window-actions').find('.email').addClass('d-none')

           }
        })

        $("#app").on('click', '.create_employee_modal_show', () => {
            $('#permissions').attr('data-employee-id', '');
        })
        $('#app').on('focus', '#edit-employee-modal', (e) => {

            $('#social_security').mask('000-00-0000', {placeholder: '___-__-____'});
            $('#phone_number').mask('000-000-0000', {placeholder: '___-___-____'});
            $('#email').attr('disabled',true)
            $('#permissions').attr('data-is_admin') != 0 ? $('#personal_permissions').prop('disabled', true) : $('#personal_permissions').prop('disabled', false)
        })
            $('#app').on('click', '#edit-employee-modal #personal_permissions', (e) => {
                let employeeId = $('#permissions').attr('data-employee-id');
                $.ajax({
                    type: 'GET',
                    url: `/employees/employee/${employeeId}`,
                    success: function (response) {
                        $('#modal_permissions #position').val(response.position)
                        for (let permission of $('#permissions .permission input[type=checkbox]')) {
                            permission = $(permission);
                            if (response.permissions.indexOf(permission.attr('id')) != -1) {
                                permission.prop('checked', true);
                            } else {
                                permission.prop('checked', false);
                            }
                        }
                        $('#modal_permissions').modal('show');
                    },
                });
            });


        $('#app').on('change', '#modal_permissions #position', function (){
                let role = $('#modal_permissions #position').val()
                    for (let permission of $('#permissions .permission input[type=checkbox]')) {
                        permission = $(permission);
                        if (permissions[role].indexOf(permission.attr('id')) !=-1) {
                            permission.prop('checked', true);
                        } else {
                            permission.prop('checked', false);
                        }
                    }
        })


        $('body').on('click', '.change-permissions, .permission-modal', (e) => {
            function openPermissionsModal(employeeId) {
                let data;
                $.ajax({
                    type: 'GET',
                    url: `/employees/employee/${employeeId}`,
                    success: function (response) {
                        $('#modal_permissions #position').val(response.position)
                        for (let permission of $('#permissions .permission input[type=checkbox]')) {
                            permission = $(permission);
                            if (response.permissions.indexOf(permission.attr('id')) != -1) {
                                permission.prop('checked', true);
                            } else {
                                permission.prop('checked', false);
                            }
                        }
                        $('#modal_permissions').modal('show');
                    },
                });
            }
       
            const target = $(e.currentTarget)
            const employeeId = target.attr('data-user_id') ?? target.attr('data-id');
            openPermissionsModal(employeeId);
            $('#permissions').attr('data-employee-id', employeeId);
        });

        $('.account_collapse').on('click', (e) => {
            const arrow = $(e.target).parents('tr').find('.fa-chevron-down');
            const transformValue = arrow.css('transform');
            if(transformValue === 'none') {
                arrow.css('transform', 'rotate(180deg)');
            } else {
                arrow.css('transform', '');
            }
        });

        $('#modal_permissions .close').on('click', (e) => {
            $('[name=change_permissions]').prop('checked', false);
        });

        $('body').on('click', '#confirm-action-modal .confirm-btn', function () {
            // check if this needed page
            if (location.pathname == "/employees") {

                const employeeId = $(this).data('id')
                const employeeStatus = $(this).data('status')
                const confirmed = true
                if (!isNaN(employeeStatus)) {
                    $.ajax({
                        method: 'GET',
                        data: {
                            confirmed: confirmed,
                            id: employeeId,
                            status: employeeStatus
                        },
                        url: `/employees/employee/${employeeId}/status`,
                        success: (response) => {
                            //   $(`tr#${employeeId} span.employee-status`).text(response);
                            $('#confirm-action-modal').modal('hide')
                            window.location.reload()

                        },
                        error: (response) => {
                            if (response.responseJSON && response.responseJSON.billing_url) {
                                window.location.assign(response.responseJSON.billing_url);
                            }
                            $('#confirm-action-modal').modal('hide')
                        }
                    })
                } else {
                    $.ajax({
                        method: 'POST',
                        data: {
                            id: employeeId,
                            confirmed: confirmed,
                        },
                        url: `/employees/employee/${employeeId}/delete`,
                        success: (response) => {
                            //   $(`tr#${employeeId} span.employee-status`).text(response);
                            $('#confirm-action-modal').modal('hide')
                            window.location.reload()

                        },
                        error: (response) => {
                            $('#confirm-action-modal').modal('hide')
                        }
                    })
                }
            }
        });

        $('body').on("keyup", "#search_employee",function() {
            let value = $(this).val().toLowerCase();
            $("#employee_table .row_user").filter(function() {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1 || $(this).next().text().toLowerCase().indexOf(value) > -1)
            });
        });
    },


    initPagination(){
        if (window.location.pathname == '/employees') {
            const section = new Section('employees');
            section.show();
        }
    },

    initEmployeeDropzone() {
        // Initialize dropzone for employee modals when they are shown
        $(document).on('shown.bs.modal', '[id^="employee-"]', function() {
            const modalId = $(this).attr('id');
            if (modalId && modalId.startsWith('employee-')) {
                const employeeId = modalId.replace('employee-', '');
                if (employeeId) {
                    // Import CRUDFabric and Employee dynamically
                    import('./CRUDs/CRUDFabric').then(({ CRUDFabric }) => {
                        const EmployeeClass = CRUDFabric.getClass('employee');
                        if (EmployeeClass) {
                            const employee = new EmployeeClass(employeeId);
                            if (employee && typeof employee.scopeOpenDropZoneListener === 'function') {
                                employee.scopeOpenDropZoneListener();
                            }
                        }
                    }).catch(err => {
                        console.error('Failed to initialize employee dropzone:', err);
                    });
                }
            }
        });
    },

    initLogs() {
        $('body').off('click', '.entity-logs-btn')
            .on('click', '.entity-logs-btn', function() {
                const entity = $(this).data('entity');
                const entity_id = $(this).data('entity_id');
                if (entity && entity_id) {
                    try {
                        const EntityObj = CRUDFabric.getObject(entity, entity_id);
                        if (EntityObj) {
                            EntityObj.openModal('logs');
                        }
                    } catch (err) {
                        console.error('Failed to open logs modal:', err);
                    }
                }
            });
    },
    validationFormFields(form_id, form_data, validation_fields, isSelectErrorFields=false){
        let validate_flag = true;

        let rules_validation = {};
        validation_fields.forEach(element => {
            rules_validation[element] = ['required'];
        });

        const validator = new Validator(rules_validation);
        validation_fields.forEach(element => {
            if (validator.validate(element, form_data.get(element))) {
                if(isSelectErrorFields)
                    $('#'+form_id+' [name="'+element+'"]').removeClass('border-danger').css('border','');
            }else{
                validate_flag = false;
                if(isSelectErrorFields)
                    $('#'+form_id+' [name="'+element+'"]').addClass('border-danger').css('border','2px solid');
            }
        });

        return validate_flag;
    }


}
